export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/72a061e4da900bb3a21b7904c48e0b41.svg";